// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"3fa24709","262":"fc788d7d","498":"03f7aeb3","787":"0be315e8"}[chunkId] + ".chunk.js";
};